import {Link} from "react-router-dom";
import {PktIcon} from "@oslokommune/punkt-react";
import React from "react";

type BackLinkProps = {
    url: string
    text: string;
}

export function BackLinkInternNavigasjon({url, text}: BackLinkProps) {
    // TODO: Dette er en gjenskapning av PktBacklink men med react-routers link
    // Om Punkt får støtte for custom componenter inn i PktBacklink kan denne fjernes

    return (
        <nav
            className={"pkt-cell pkt-cell--span12 pt-size-8 pkt-back-link"}
            aria-label={"Gå tilbake et steg"}
        >
            <Link to={url} className={"pkt-link pkt-link--icon-left"}>
                <PktIcon
                    name="chevron-thin-left"
                    className={"pkt-back-link__icon pkt-link__icon"}
                />
                <span className={"pkt-back-link__text"}>{text}</span>
            </Link>
        </nav>
    );
}

